import React, { PureComponent } from 'react'
import { PropTypes } from 'prop-types'
import { Link } from 'react-router-dom'
import config from 'config'

import logoImg from 'assets/img/dofe-logo-small.png'
import styles from './logo-min.styl'


export default class LogoMin extends PureComponent {
  static propTypes = {
    className: PropTypes.string
  }
  static defaultProps = {
    className: ''
  }

  render() {
    const { className } = this.props

    const LogoElement = (
      <img
        className={`${className} ${styles.img}`}
        src={logoImg}
        alt="Dukes of Edinburgh logo"
        width="48"
        height="37"
      />
    )

    return <Link to={`${config.publicPath}/`}>{LogoElement}</Link>
  }
}
